// extracted by mini-css-extract-plugin
export default {"row":"styles_row__Afeph","editBtnWrapper":"styles_editBtnWrapper__lIbEu","editBtn":"styles_editBtn__DfHPs"};